import { STORAGE_KEYS } from "../constants/userConstant";
import { clearAuthTokens, getAuthTokens } from "./authStorage";
export const getTokens = () => {
  return getAuthTokens();
};

export const removeTokens = () => {
  clearAuthTokens();
  localStorage.removeItem(STORAGE_KEYS.USER_DETAILS);
};

//cart
export const addToLocalCart = (cart) => {
    localStorage.setItem(STORAGE_KEYS.CART_BOOK, JSON.stringify(cart));
};

export const getLocalCart = () => {
    const cartData = localStorage.getItem(STORAGE_KEYS.CART_BOOK);
    return cartData ? JSON.parse(cartData) : null; 
};

export const clearLocalCart = () => {
    localStorage.removeItem(STORAGE_KEYS.CART_BOOK);
};
  
  // capitalize
  export const capitalizeFirstLetter = (name) => {
    if (typeof name !== 'string' || !name.trim()) {
      return ''; 
    }
  
    return name
      .trim()
      .split(' ')
      .filter(word => word)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
//format date
 export  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); 
    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const year = date.getFullYear(); 

    return `${day}.${month}.${year}`;
  };

  //convert date
 export const convertDateFormat = (dateStr) => {
    const [day, month, year] = dateStr?.split(".");
    return `${year}-${month}-${day}`;
  };

  
  export const handleKeyDown = (e) => {
    e.preventDefault();
  };

  export const capitalizeLabel = (label) => label.charAt(0).toUpperCase() + label.slice(1);


export const formatDateMonth = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Format the date to "21 November 2024"
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
};


export const extractApiFileNames = (imageData) => {

  try {
    if (!imageData || imageData === "NA" || imageData.trim() === "") {
      return [];
    }

    const parsedData = JSON.parse(imageData);
  
    let fileNames = [];

    if (Array.isArray(parsedData)) {
      parsedData.forEach((item) => {
        if (item?.apiFileName) {
          fileNames.push(item?.apiFileName);
        } else {
          for (let key in item) {
            if (item[key]?.apiFileName) {
              fileNames.push(item[key]?.apiFileName);
            }
          }
        }
      });
      return fileNames;
    }
    return [];
  } catch (error) {
    console.error("Failed to parse imageData:", error);
    return [];
  }
};


export const parseImageData = (imageData) => {
  if (!imageData || imageData === "") {
    return []; // Return an empty array if imageData is invalid
  }
  
  try {
    return JSON.parse(imageData); // Try to parse the data
  } catch (error) { 
    return []; // Return empty array in case of error
  }
};

export const transformImageData = (input) => {
  if (!input || input.length === 0) {
    return [];
  }

  const obj = input[0]; // Extract the first object from the input array.

  // If the object has no keys, return an empty array.
  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return [];
  }

  const maxIndex = Math.max(...keys.map(Number));
  const result = new Array(maxIndex + 1); // Create an array with empty slots.

  for (const [key, value] of Object.entries(obj)) {
    result[Number(key)] = value; // Assign values to the respective indices.
  }

  return result;
}

export const groupElementsByRow = (elements) => {
  
  const rows = [];
  let currentRow = [];

  elements?.forEach((item) => {
    const { index } = item.element;

    if (index === 0 && currentRow.length > 0) {
      rows.push(currentRow); 
      currentRow = []; // Reset the current row
    }
    currentRow.push(item); // Add the item to the current row
  });

  if (currentRow.length > 0) {
    rows.push(currentRow); // Push the final row
  }

  return rows;
};

export const isObject = (value) =>{
  return value !== null && typeof value === 'object';
}

export const isArrayEmptyOrContainsEmptyObject = (arr) =>  {
  // Check if the array is empty
  if (arr.length === 0) return true;

  // Check if every element in the array is an empty object
  return arr.every(obj => 
      typeof obj === 'object' && 
      obj !== null && 
      Object.keys(obj).length === 0
  );
}

export const checkElementsFilled = (groupedRows , formData) => {
  
  let allTextFieldsFilled = true;
  let allImageFieldsFilled = true;
  let hasTextElements = false;
  let hasImageElements = false;
  
  // Track family tree inputs separately
  let mumSideTreeFilled = true;
  let dadSideTreeFilled = true;
  let hasMumSideTree = false;
  let hasDadSideTree = false;

  groupedRows.forEach((group) => {
    group.forEach((question) => {
      const { element } = question;

      // Check text fields
      if (
        [
          "TextBox",
          "UserInput",
          "TextArea",
          "DateTime",
          "TimeInput",
          "LeftHeadChestOnTummy",
          "RolledOver",
          "SatByYouself",
          "Crawled",
          "StoodByYourSelf",
          "Walked"
        ].includes(element?.elementType)
      ) {
        hasTextElements = true;
        const value = formData[element?.position];
        if (!value || value.trim?.() === "") {
          allTextFieldsFilled = false;
        }
      }

      // Check image fields
      if (
        ["FileUpload", "FileUploadWithCaption"].includes(
          element?.elementType
        )
      ) {
        hasImageElements = true;
        // console.log("formData",formData);

        let imageValue = formData[element?.position];
        // console.log("imageValue before", imageValue);

        if (!imageValue || imageValue === "NA") {
          // console.log("Initializing imageValue to an empty array");
          imageValue = [];
        } else if (Array.isArray(imageValue)) {
          // console.log("imageValue is already an array, no changes made");
          // Do nothing; imageValue remains as is.
        } else if (isObject(imageValue)) {
          // console.log("imageValue is an object, converting to array");
          imageValue = Object.values(imageValue);
        } else {
          // console.log("imageValue is a JSON string, parsing it");
          try {
            imageValue = JSON.parse(imageValue);
          } catch (error) {
            // console.error("Failed to parse imageValue:", error);
            imageValue = [];
          }
        }

        if (!isArrayEmptyOrContainsEmptyObject(imageValue)) {
          allImageFieldsFilled = true;
        } else {
          allImageFieldsFilled = false;
        }
      }

      if(["GiftInput"].includes(
        element?.elementType
      )){
        hasTextElements = true;
        const value = formData[element?.position];
        value?.InputGroups?.map((group, groupIndex) =>
          group?.Fields?.map((field, fieldIndex) => {
            if (!field.Value && field.Value == "") {
              allTextFieldsFilled = false;
            }  
          })
        )
      }

      if(["ImmediateFamilyTreeInput"].includes(
        element?.elementType
      )){
        hasTextElements = true;
        let value = formData[element?.position];
        value = JSON.parse(value);          
        Array.isArray(value) &&
          value.map((side, sideIndex) => (
            <div key={sideIndex} style={{ marginBottom: "20px" }}>

              {side.ImmediateFamilyGroups?.map(
                (group, groupIndex) => (
                  <div key={groupIndex}>
                    {group.Fields.map((field, fieldIndex) => {
                      if (!field.Value && field.Value == "") {
                        allTextFieldsFilled = false;
                      }
                    })}
                  </div>
                )
              )}

              {side.GrandParentsFamilyGroups?.map(
                (group, groupIndex) => (
                  <div key={groupIndex}>
                    {group.Fields.map((field, fieldIndex) => {
                    if (!field.Value && field.Value == "") {
                      allTextFieldsFilled = false;
                    }
                    })}
                  </div>
                )
              )}

              {side.OtherFamilyGroups?.map(
                (group, groupIndex) => (
                  <div key={groupIndex}>
                    {group.Fields.map((field, fieldIndex) => {
                     if (!field.Value && field.Value == "") {
                      allTextFieldsFilled = false;
                    }
                    })}
                  </div>
                )
              )}
            </div>
          ))
      }

        if (["MumSideFamilyTreeInput"].includes(element?.elementType)) {
          hasTextElements = true;
          hasMumSideTree = true;
          let value = formData[element?.position];
          value = JSON.parse(value);
          
            Array.isArray(value) &&
              value.map((side, sideIndex) => (
                <div key={sideIndex} style={{ marginBottom: "20px" }}>
                  {side.GrandParentsFamilyGroups?.map((group, groupIndex) => (
                    <div key={groupIndex}>
                      {group.Fields.map((field, fieldIndex) => {
                        if (!field.Value && field.Value == "") {
                          mumSideTreeFilled = false;
                        }
                      })}
                    </div>
                  ))}

                  {side.OtherFamilyGroups?.map((group, groupIndex) => (
                    <div key={groupIndex}>
                      {group.Fields.map((field, fieldIndex) => {
                        if (!field.Value && field.Value == "") {
                          mumSideTreeFilled = false;
                        }
                      })}
                    </div>
                  ))}
                </div>
              ));
          
        }

         if (["DadSideFamilyTreeInput"].includes(element?.elementType)) {
           hasTextElements = true;
           hasDadSideTree = true;
           let value = formData[element?.position];
           value = JSON.parse(value);
           
             Array.isArray(value) &&
               value.map((side, sideIndex) => (
                 <div key={sideIndex} style={{ marginBottom: "20px" }}>
                   {side.GrandParentsFamilyGroups?.map((group, groupIndex) => (
                     <div key={groupIndex}>
                       {group.Fields.map((field, fieldIndex) => {
                         if (!field.Value && field.Value == "") {
                           dadSideTreeFilled = false;
                         }
                       })}
                     </div>
                   ))}

                   {side.OtherFamilyGroups?.map((group, groupIndex) => (
                     <div key={groupIndex}>
                       {group.Fields.map((field, fieldIndex) => {
                         if (!field.Value && field.Value == "") {
                           dadSideTreeFilled = false;
                         }
                       })}
                     </div>
                   ))}
                 </div>
               ));
           
         }
    });
  });

  // Apply OR logic for family trees: if either mum or dad side is filled, consider it valid
  if ((hasMumSideTree || hasDadSideTree) && !(mumSideTreeFilled || dadSideTreeFilled)) {
    allTextFieldsFilled = false;
  }

    // If no text elements were found, keep isTextFilled as false
    if (!hasTextElements) allTextFieldsFilled = false;
    // If no image elements were found, keep isImageFilled as false
    if (!hasImageElements) allImageFieldsFilled = false;

  return {
    allTextFieldsFilled,
    allImageFieldsFilled,
  };
};


 export const mergePreviewData = (formData, previewData , filteredElements) => {
    const mergedPreviewData = {
      ...previewData,
      customPageName: formData.customPageName ? formData.customPageName : previewData.customPageName,
      elements: filteredElements?.map((item) => {
        const position = item.element.position; 
        const formValue = formData[position]; 
  
        return {
          ...item,
          element: {
            ...item.element,
            value: formValue || "", 
          },
        };
      }),
    };
    return mergedPreviewData;
  }

  export const convertDateToWords = (dateString) => {
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];
    
    const [year, month, day] = dateString.split('-');
    
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  }

  export const cmsRoutes = {
  about: {
    id: 1,
    path: '/about'
  },
  shipping: {
    id: 5,
    path: '/shipping-and-delivery'
  },
  privacy: {
    id: 4,
    path: '/privacy-policy'
  },
  terms: {
    id: 3,
    path: '/terms-of-service'
  }
};

export const pathToIdMap = {
    '/about': 1,
    '/shipping-and-delivery': 5,
    '/privacy-policy': 4,
    '/terms-of-service': 3
  };


export function scrollToTopUniversal() {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // Immediate scroll
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // Handle Safari viewport timing
  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  });

  // Fallback for delayed layout or soft keyboard on iOS
  setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 150);
}

const CUSTOM_PAGE_NAME_SUPPORTED_PAGES = [
  "All about Mum",
  "All about Dad"
];

export const supportsCustomPageName = (pageName) => {
  return CUSTOM_PAGE_NAME_SUPPORTED_PAGES.includes(pageName);
};

// export const VALID_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];


export function getFileNameFromUrl(url) {
  try {
    const pathname = new URL(url).pathname;
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}

export const VALID_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/jfif",
  "image/pjpeg",
  "image/heic",
  "image/heif",
  "image/heic-sequence",
  "image/heif-sequence",
  "image/hevc",
];

export const VALID_IMAGE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "jfif",
  "heic",
  "heif",
  "heics",
  "heifs",
  "hevc",
];

// Mirrors the backend's validNamePattern (^[a-zA-Z0-9_\-\.]+$) — strips any
// character outside that set (spaces, parentheses, etc.) instead of just
// whitespace, e.g. "IMG_9979 (4).jpeg" -> "IMG_99794.jpeg".
export const sanitizeFileName = (fileName) => {
  return fileName?.replace(/[^a-zA-Z0-9_\-.]/g, "") || fileName;
};

export const isValidImage = (file) => {
  const mimeType = file.type?.toLowerCase() || "";
  const extension = file.name?.split(".").pop()?.toLowerCase() || "";

  return (
    VALID_IMAGE_TYPES.includes(mimeType) ||
    VALID_IMAGE_EXTENSIONS.includes(extension)
  );
};